
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/codigo-de-etica",
      function () {
        return require("private-next-pages/codigo-de-etica/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/codigo-de-etica"])
      });
    }
  